import React from 'react';
import PropTypes from 'prop-types';

import { append, contains, remove } from 'ramda';

import PortalCheckbox from '../PortalCheckbox';

import cx from 'classnames';
import s from '../FormElement.css';


const updateValue = (event, option, checked, onChange) => {
  /*
    A checklist option with an empty label should default to "yes".  This helps validation of required fields.
    Empty values are interpreted as no response by the validator.
  */
  const nonEmptyOption = option === "" ? "yes" : option;
  const index = checked.indexOf(nonEmptyOption);
  const value = index > -1 ? remove(index, 1, checked) : append(nonEmptyOption, checked);
  onChange(event, value);
}

const PortalCheckboxGroup = ({
  className, description, disabled, errorText, id,
  label, name, onChange, options, required, checked, onBlur,
}) => {
  const checkboxes = options.map((option, index) => {
    const isChecked = checked && contains(option === "" ? "yes" : option, checked);
    return <PortalCheckbox key={index}
      className={s.groupItem}
      id={id + '__' + index.toString()}
      name={option}
      label={option}
      value={index}
      disabled={disabled}
      onChange={event => { if (onChange) updateValue(event, option, checked, onChange) }}
      checked={isChecked}
      onBlur={onBlur}
    />;
  });

  return (
    <div className={cx(s.component, className, { [`${s.disabled}`]: disabled, [`${s.error}`]: errorText })}>
      {label &&
        <label htmlFor={id} className={s.label}>{label}</label>
      }

      <div className={s.container}>{checkboxes}</div>

      {errorText &&
        <label className={s.errorText}>{errorText}</label>
      }

      {description &&
        <label className={s.description}>{description}</label>
      }
    </div>
  );
};

PortalCheckboxGroup.propTypes = {
  className: PropTypes.string,
  description: PropTypes.string,
  disabled: PropTypes.bool,
  errorText: PropTypes.node,
  id: PropTypes.string.isRequired,
  label: PropTypes.node,
  name: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.array.isRequired,
  required: PropTypes.bool,
  checked: PropTypes.array,
  onBlur: PropTypes.func,
};

export default PortalCheckboxGroup;



// WEBPACK FOOTER //
// ./src/components/FormElements/PortalCheckboxGroup/PortalCheckboxGroup.js